import { ApiABExperiment } from 'api/types/ApiABExperiment';
import { postJson } from 'utils/http';

export async function setABExperimentBucket(
  experimentId: string,
  bucket?: string
): Promise<ApiABExperiment[]> {
  const { abExperiments } = await postJson<{
    abExperiments: ApiABExperiment[];
  }>('/data/ab/assignments', { id: experimentId, bucket });

  return abExperiments;
}
